module.exports = __webpack_public_path__ + "img/jiejfa.9622adbe.png";